import React from 'react';
import { Redirect } from 'react-router-dom';
import { checkPermission, Constants } from 'utils';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';

const Reports = () => {
	const user = useSelector((state: RootState) => state.user);

	if (user?.level_id == Constants.LEVELS.CLIENT || user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) {
		if (checkPermission(Constants.MODULES.KYC,'read'))
			return <Redirect to="/client/verifications/report" />
		if (checkPermission(Constants.MODULES.BLACK_LIST,'read'))
			return <Redirect to="/client/verifications/black-list" />
	}
	else if (user?.level_id == Constants.LEVELS.ADMIN || user?.level_id == Constants.LEVELS.MODERATOR) {
		if (checkPermission(Constants.MODULES.ADMIN_KYC,'read'))
			return <Redirect to="/admin/verifications/report" />
		if (checkPermission(Constants.MODULES.ADMIN_BLACK_LIST,'read'))
			return <Redirect to="/admin/verifications/black-list" />
	}
}

export default Reports;